import React from 'react';
import { maxBreakpoints } from '@noths/polaris-client-ribbons-base';
import { Image } from '@noths/polaris-client-ribbons-design-system';
import { getContentstackImageURL } from '@noths/polaris-client-utils';

import * as styles from './InListingCallout.styles';

const createIdFromText = (text: string) => {
  return text
    .replace(/\s+/g, '-')
    .toLowerCase()
    .replace(/[^a-z0-9\-]/g, '');
};

export interface InListingCalloutProps {
  ctaHref: string;
  ctaText: string;
  heading: string;
  imgAlt?: string;
  /** @param imgSrc Must be served from Contentstack (due to on-demand image resizing) */
  imgSrc: string;
  onClick?: (ev: React.MouseEvent<HTMLAnchorElement>) => void;
}

export const InListingCallout = ({
  ctaHref,
  ctaText,
  heading,
  imgAlt = '',
  imgSrc,
  onClick,
}: InListingCalloutProps) => {
  const id = 'in-listing-callout-' + createIdFromText(heading);
  const mobileImageSrc = getContentstackImageURL(imgSrc, maxBreakpoints.S);
  const tabletImageSrc = getContentstackImageURL(imgSrc, 990);
  const desktopImageSrc = getContentstackImageURL(imgSrc, 1038);

  return (
    <a aria-labelledby={id} css={styles.root} href={ctaHref} onClick={onClick}>
      <Image
        alt={imgAlt}
        loading="lazy"
        sizes={`(max-width: ${maxBreakpoints.S}px) 100vw, (max-width: ${maxBreakpoints.M}px) 990px, 1038px`}
        src={mobileImageSrc}
        srcSet={`${mobileImageSrc} 767w, ${tabletImageSrc} 990w, ${desktopImageSrc} 1038w`}
      />
      <h3 id={id}>{heading}</h3>
      <strong>{ctaText} →</strong>
    </a>
  );
};
